import { jsx, jsxs } from "react/jsx-runtime";
import { useState, useMemo } from "react";
import StyledTooltip from "../../../../../components/styled-tooltip/styled-tooltip.js";
import AnamnesisStatusPopover from "../anamnesis-status-popover/anamnesis-status-popover.js";
import { useGenerateAnamnesisCode } from "../../hooks/useGenerateAnamnesisCode.js";
import { useSendAnaLinkViaSms } from "../../hooks/useSendAnaLinkViaSms.js";
import { useLabels } from "../../labels.provider.js";
import { DocumentStatus, ActiveCodeType } from "../../patient-today-list.types.js";
import { useCodeSSE, CodeType } from "../../../../../hooks/sse/useCodeSSE.js";
import { AnamnesisAttentionIcon, AnamnesisInProgressIcon, AnamnesisDoneIcon, StatusChip, StatusButton } from "./anamnesis-status.styles.js";
import "@mui/material";
import "@mui/icons-material/Refresh.js";
import "@mui/icons-material/RefreshRounded.js";
import "../AxiosProvider.js";
import "axios";
import "../../helpers.js";
import "libphonenumber-js/mobile";
import "../../hooks/useRecollectAnamnesis.js";
import "@tanstack/react-query";
import "../../query-key-provider.js";
import "../../hooks/useRecollectFactoringAgreement.js";
import "../../../../../utils/date/formatDefault.js";
import "../../../../../constants/date/date.js";
import "../../../../../utils/date/format.js";
import "date-fns";
import "../../../../../utils/fp/flow/flow.js";
import "../../../../../utils/date/toDate.js";
import "date-fns/fp/parseISO";
import "../anamnesis-status-popover/anamnesis-status-popover.styles.js";
import "@mui/icons-material/CheckRounded.js";
import "@mui/icons-material/CloseRounded.js";
import "@mui/material/styles";
import "../../../../../components/icons/MessageBubble/MessageBubble.js";
import "../../../../../components/icons/MainIcon/MainIcon.js";
import "../../../../../components/icons/TabletIcon/TabletIcon.js";
import "../../../../../hooks/useServerSentEvent.js";
import "../../../../../constants/serverSentEvents/serverSentEvents.js";
import "../../../../../type/InternalServerSentEvents.js";
import "../../assets/icons/AnamnesisAttention.js";
import "../../assets/icons/AnamnesisDone.js";
import "../../assets/icons/AnamnesisInProgress.js";
const statusIconMap = {
  [DocumentStatus.INVALID]: /* @__PURE__ */ jsx(AnamnesisAttentionIcon, {}),
  [DocumentStatus.MISSING]: /* @__PURE__ */ jsx(AnamnesisAttentionIcon, {}),
  [DocumentStatus.IN_PROGRESS]: /* @__PURE__ */ jsx(AnamnesisInProgressIcon, {}),
  [DocumentStatus.DONE]: /* @__PURE__ */ jsx(AnamnesisDoneIcon, {})
};
const AnamnesisStatus = ({
  anamnesis,
  factoring,
  activeCode,
  patientReferenceId,
  patientPhoneNumber,
  isDocumentActionsActive
}) => {
  const { labels, language = "de" } = useLabels();
  const [anchorEl, setAnchorEl] = useState(null);
  const [isSmsSent, setIsSmsSent] = useState(!!activeCode && ActiveCodeType.SMS === activeCode.type);
  const {
    mutateAsync: generateCode,
    isLoading: isGeneratingCodeLoading,
    data: generatedCodeRes
  } = useGenerateAnamnesisCode();
  const {
    mutateAsync: sendSms,
    isLoading: isSendingSmsLoading,
    data: smsSentRes
  } = useSendAnaLinkViaSms({
    onSuccess: () => {
      setIsSmsSent(true);
    }
  });
  useCodeSSE((event) => {
    if (event.type === CodeType.SMS && event.patientResourceId.referenceId === patientReferenceId) {
      setIsSmsSent(true);
    }
  });
  const status = useMemo(() => {
    const isDone = anamnesis.status === DocumentStatus.DONE && factoring.status === DocumentStatus.DONE;
    const isInProgress = activeCode || generatedCodeRes || smsSentRes || [anamnesis.status, factoring.status].includes(DocumentStatus.IN_PROGRESS);
    if (isDone)
      return DocumentStatus.DONE;
    if (isInProgress)
      return DocumentStatus.IN_PROGRESS;
    return DocumentStatus.MISSING;
  }, [anamnesis.status, factoring.status, activeCode, generatedCodeRes, smsSentRes]);
  const generatedCode = useMemo(() => {
    return (activeCode == null ? void 0 : activeCode.value) || generatedCodeRes;
  }, [activeCode == null ? void 0 : activeCode.value, generatedCodeRes]);
  const togglePopover = (e) => {
    setAnchorEl((prev) => prev ? null : e.currentTarget);
  };
  const onPopoverClose = () => {
    setAnchorEl(null);
  };
  const onGenerateCode = () => {
    if (!patientReferenceId)
      return;
    generateCode(patientReferenceId);
  };
  const onSendSms = async () => {
    if (!patientReferenceId)
      return;
    sendSms({
      patientReferenceId,
      language
    });
  };
  return /* @__PURE__ */ jsxs("div", { "data-testid": "anamnesis-status-container", children: [
    /* @__PURE__ */ jsx(
      StatusChip,
      {
        isOpen: Boolean(anchorEl),
        status,
        label: /* @__PURE__ */ jsx(StyledTooltip, { title: labels.anamnesis.tooltip, placement: "top", children: /* @__PURE__ */ jsx(StatusButton, { variant: "borderless", onClick: togglePopover, disableRipple: true, children: statusIconMap[status] }) })
      }
    ),
    anchorEl && /* @__PURE__ */ jsx(
      AnamnesisStatusPopover,
      {
        anchorEl,
        onClose: onPopoverClose,
        anamnesis,
        factoring,
        patientReferenceId,
        patientPhoneNumber,
        onSendSms,
        onGenerateCode,
        isSmsSent,
        generatedCode,
        loading: { isGeneratingCodeLoading, isSendingSmsLoading },
        isDocumentActionsActive
      }
    )
  ] });
};
export {
  AnamnesisStatus as default
};
